import * as React from 'react'
import { inject, observer } from 'mobx-react'
import Switch from 'react-bootstrap-switch'
import HttpActionsService from '../../Services/HttpActionsService'
import { Label } from 'react-bootstrap'
import LocalizationStore from '../../Stores/LocalizationStore'
import { User } from '../../Model/User'
import UserStore from '../../Stores/UserStore'

interface IUserIsBlockedComponentProps {
    user: User,
    showLabels?: boolean,
    httpActionsService?: HttpActionsService,
    userStore?: UserStore,
    localizationStore?: LocalizationStore
}

@inject('localizationStore')
@inject('userStore')
@inject('httpActionsService')
@observer
export default class UserIsBlockedComponent extends React.Component<IUserIsBlockedComponentProps> {

    constructor(props: IUserIsBlockedComponentProps) {
        super(props)
    }

    handleTogleBlockUser(el: any) {
        this.props.httpActionsService!.toggleBlockUser(this.props.user.id)
    }

    render() {
        const { localizationStore, userStore } = this.props
        if (!(userStore!.checkAdmin || userStore!.checkSuperAdmin)) {
            return null
        }

        let lockoutEnabled = this.props.user && this.props.user!.lockoutEnabled &&
            this.props.user!.lockoutEnd !== null &&
            new Date(this.props.user!.lockoutEnd!) > new Date()

        return (
            <div className="switchForm">
                <Label
                    hidden={lockoutEnabled}
                >
                    {localizationStore!.t('UnBlocked')}
                </Label>
                <Label
                    hidden={!lockoutEnabled}
                >
                    {localizationStore!.t('Blocked')}
                </Label>
                <Switch
                    wrapperClass="switchWrapper"
                    labelText=""
                    onText=""
                    offText=""
                    onChange={(el) => this.handleTogleBlockUser(el)}
                    value={lockoutEnabled}
                />
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Components/UserIsBlockedComponent/index.tsx